import { CardHeader } from "reactstrap";
import styled from "styled-components"


export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: "text-white bg-header",
}))`
font-family: "Verdana";
font-size: 1.3em;`;
